import { ROUTES } from '@/shared/constants/routes';
import { selectCurrentProject } from '@/viewmodel/features/project';
import { useProjectById } from '@/viewmodel/features/project';
import type { ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { Navigate, useSearchParams } from 'react-router-dom';

export function ProtectedRouteProject({ children }: Readonly<{ children: ReactNode }>) {
  const currentProject = useSelector(selectCurrentProject);
  const [params] = useSearchParams();
  const w = params.get('w');
  const p = params.get('p');
  const { project, isPending } = useProjectById(!currentProject && w ? p : undefined);

  const projectsRoute = w ? `${ROUTES.PROJECTS}?w=${encodeURIComponent(w)}` : ROUTES.PROJECTS;

  if (currentProject) return <>{children}</>;
  if (!w || !p) return <Navigate to={projectsRoute} />;
  if (isPending) return <>{children}</>;
  if (project?.workspace_id === w) return <>{children}</>;
  return <Navigate to={projectsRoute} />;
}
